import { render, staticRenderFns } from "./flats-list-table.vue?vue&type=template&id=2514f648"
import script from "./flats-list-table.vue?vue&type=script&lang=js"
export * from "./flats-list-table.vue?vue&type=script&lang=js"
import style0 from "./flats-list-table.vue?vue&type=style&index=0&id=2514f648&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports